import { render, staticRenderFns } from "./catalog_view.vue?vue&type=template&id=cc25b75a&scoped=true&"
import script from "./catalog_view.vue?vue&type=script&lang=js&"
export * from "./catalog_view.vue?vue&type=script&lang=js&"
import style0 from "./catalog_view.vue?vue&type=style&index=0&id=cc25b75a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc25b75a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc25b75a')) {
      api.createRecord('cc25b75a', component.options)
    } else {
      api.reload('cc25b75a', component.options)
    }
    module.hot.accept("./catalog_view.vue?vue&type=template&id=cc25b75a&scoped=true&", function () {
      api.rerender('cc25b75a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/products/catalog_view.vue"
export default component.exports